<table mat-table [dataSource]="servers">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>ID</th>
    <td mat-cell *matCellDef="let p">
      {{p.id}}
    </td>
  </ng-container>
  <ng-container matColumnDef="identifier">
    <th mat-header-cell *matHeaderCellDef>Identifier</th>
    <td mat-cell *matCellDef="let p">
      {{p.identifier}}
    </td>
  </ng-container>
  <ng-container matColumnDef="ip">
    <th mat-header-cell *matHeaderCellDef>IP</th>
    <td mat-cell *matCellDef="let p">
      {{p.ipAddress}}
    </td>
  </ng-container>
  <ng-container matColumnDef="port">
    <th mat-header-cell *matHeaderCellDef>Port</th>
    <td mat-cell *matCellDef="let p">
      {{p.port}}
    </td>
  </ng-container>
  <ng-container matColumnDef="players">
    <th mat-header-cell *matHeaderCellDef>Players</th>
    <td mat-cell *matCellDef="let p">
      {{p.playerCount}}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns" routerLink="/servers/{{row.identifier}}"></tr>
</table>
